// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yJzZu","controls":"styles_controls__4_l-4","charLimit":"styles_charLimit__fbdM6","input":"styles_input__tctPI","send":"styles_send__1v9rQ"};